// extracted by mini-css-extract-plugin
export default {"cards":"Portfolio_cards__ihwI8"};